/**
 * Top 100 most common passwords to reject
 * Source: Aggregated from security breach databases (HaveIBeenPwned, NordPass)
 */
export const COMMON_PASSWORDS = [
  '123456',
  '123456789',
  'qwerty',
  'password',
  '12345678',
  '111111',
  '123123',
  '1234567890',
  '1234567',
  'qwerty123',
  '000000',
  'password123',
  '1234',
  'password1',
  '12345',
  '123',
  '1q2w3e4r',
  'abc123',
  'welcome',
  'monkey',
  'letmein',
  'dragon',
  '654321',
  'master',
  'hello',
  'freedom',
  'whatever',
  'qazwsx',
  'trustno1',
  'samsung',
  'ranger',
  'charlie',
  'donald',
  'batman',
  'hunter',
  'sunshine',
  'football',
  'ashley',
  'bailey',
  'shadow',
  'michael',
  'jennifer',
  'superman',
  '123qwe',
  'iloveyou',
  'starwars',
  'computer',
  'princess',
  'maverick',
  'cookie',
  'mustang',
  'thomas',
  'summer',
  'thunder',
  'baseball',
  'soccer',
  'jordan',
  'harley',
  'killer',
  'buster',
  'tigger',
  'robert',
  'jessica',
  'chelsea',
  'purple',
  'solo',
  'admin',
  'passw0rd',
  'p@ssword',
  'p@ssw0rd',
  'password!',
  'letme1n',
  'welcome1',
  'admin123',
  'root',
  'toor',
  'test',
  'guest',
  'oracle',
  'mysql',
  'administrator',
  'user',
  'login',
  'god',
  'love',
  'sex',
  'money',
  'secret',
  'access',
  'master123',
  'admin1234',
  '1234abcd',
  'abcd1234',
  'Password1',
  'Password123',
  'Welcome1',
  'Welcome123'
];
